import { useQuery } from '@tanstack/react-query'

import { getUserIntegrations } from '@/services/get-user-integrations'

export const GET_USER_INTEGRATIONS_QUERY = 'GET_USER_INTEGRATIONS'

export const useGetUserIntegrations = () => {
  const query = useQuery({
    queryKey: [GET_USER_INTEGRATIONS_QUERY],
    queryFn: ({ signal }) => getUserIntegrations({ signal }),
  })

  return query
}
